import { t } from 'i18next'
import { DateRangeField } from '../components/dateRangePickerWithWeekDays/DateRangePickersWithWeekDays'

export const validateDateRangePickerWithWeekDays = (
  dateRanges: DateRangeField[]
) => {
  if (!(dateRanges.length > 0)) {
    return t('validations.Invalid_dates')
  }
  if (
    dateRanges.some(({ dateRange }) => dateRange[1]?.isBefore(dateRange[0]))
  ) {
    return t('validations.Invalid_dates')
  }
  if (
    dateRanges.some(
      (dateRange) =>
        !Object.values(dateRange.daysOfWeek).some((checked) => checked)
    )
  ) {
    return t('validations.Invalid_dates')
  }
  return true
}

export const validateOnlyNumber = (string: string | number) => {
  return /^[\d.]*$/.test(string.toString())
}

export const validateOnlyInt = (string: string | number) => {
  return /^[\d]*$/.test(string.toString())
}
